































































































































import Vue from 'vue'
import Presenter, { IPresenter } from './presenter'
import dayjs from 'dayjs'
import { range, extractTargetFields, oneOf } from '@/utils/helper'
import { buildUrl } from '@/utils/url'

import Button from '@/components/shared/atoms/Button/Button'
import Input from '@/components/shared/atoms/Input'
import Select, { SelectOption } from '@/components/shared/atoms/Select'
import Checkbox from '@/components/shared/atoms/Checkbox'
import FormWrapper from '@/components/shared/organisms/FormWrapper'
import Modal from '@/components/shared/atoms/Modal'
import TermMemberContainer from '@/containers/Terms/Member'
import TermServiceContainer from '@/containers/Terms/Service'
import FormBlock from '@/components/shared/molecules/Form/FormBlock'
import RadioButtonItem from '@/components/shared/atoms/RadioButtonItem'
import ProfileValidator, { Fields, FieldErrors } from '@/utils/validators/form/Profile/Profile'
import ZipcodeSearchUseCase from '@/usecases/utils/ZipcodeSearchUseCase'
import { prefectures } from '@/const'
import { IProfileSeed, IProfileFields, isProfileFields } from '@/entities/Profile'

type ValidationTargetFields = Omit<Fields, 'email' | 'password' | 'tlsc'>

interface IData {
  isAgree: boolean
  fields: ValidationTargetFields
  enableCheckFlg: { [key in keyof ValidationTargetFields]: boolean }
  showTermModal: boolean
  showServiceModal: boolean
}

export default Vue.extend({
  components: {
    Button,
    Input,
    Select,
    FormWrapper,
    FormBlock,
    RadioButtonItem,
    Checkbox,
    Modal,
    TermMemberContainer,
    TermServiceContainer
  },
  props: {
    title: {
      type: String,
      default: 'プロフィール設定｜新規会員登録'
    },
    submitText: {
      type: String,
      default: '登録内容を確認する'
    },
    mode: {
      type: String,
      default: 'create',
      validator: oneOf(['create', 'update'])
    },
    // Only for dev use like showing stories
    devProps: {
      type: Object as () => {
        createShowError?: boolean
        createFullfilled?: boolean
        updateShowError?: boolean
        updateFullfilled?: boolean
      },
      default: null
    },
    showEmail: {
      type: Boolean,
      default: () => false
    }
  },
  data(): IData {
    return {
      isAgree: false,
      showTermModal: false,
      showServiceModal: false,
      fields: {
        firstname: '',
        lastname: '',
        firstnameRuby: '',
        lastnameRuby: '',
        nickname: '',
        tel: '',
        birthYear: null,
        birthMonth: null,
        birthDay: null,
        zipcode: '',
        prefecture: '',
        address1: '',
        address2: '',
        address3: '',
        sex: null,
        readFlag: true
      },
      enableCheckFlg: {
        firstname: false,
        lastname: false,
        firstnameRuby: false,
        lastnameRuby: false,
        nickname: false,
        tel: false,
        birthYear: false,
        birthMonth: false,
        birthDay: false,
        zipcode: false,
        prefecture: false,
        address1: false,
        address2: false,
        address3: false,
        sex: false,
        readFlag: false
      }
    }
  },
  computed: {
    presenter(): IPresenter {
      return Presenter({
        profileRepository: this.$profileRepository
      })
    },
    prefectures(): SelectOption[] {
      return prefectures.map(p => ({ text: p, value: p }))
    },
    years(): SelectOption[] {
      const thisYear = Number(dayjs().format('YYYY'))
      const year = range(thisYear - 110, thisYear)
      return year.map(y => ({ text: y + '年', value: String(y) })).reverse()
    },
    months(): SelectOption[] {
      const month = range(1, 12)
      return month.map(m => ({ text: m + '月', value: String(m) }))
    },
    days(): SelectOption[] {
      if (this.fields.birthYear && this.fields.birthMonth) {
        const year = this.fields.birthYear
        const month = Number(this.fields.birthMonth)
        // TODO: FIXME
        const lastDay = dayjs(year + '-' + month + '-' + '1', 'YYYY-M-D').daysInMonth()
        const day = range(1, lastDay)
        return day.map(d => ({ text: d + '日', value: String(d) }))
      } else {
        const day = range(1, 31)
        return day.map(d => ({ text: d + '日', value: String(d) }))
      }
    },
    formErrors(): FieldErrors {
      const targetFields = extractTargetFields(this.fields, this.enableCheckFlg)
      return ProfileValidator.validate(targetFields)
    },
    isFullfilled(): boolean {
      if (this.mode === 'update') {
        return isProfileFields(this.fields)
      }

      // TODO: 要改善
      const { firstname, lastname, firstnameRuby, lastnameRuby, birthYear, birthMonth, birthDay, prefecture, readFlag } = this.fields
      if (firstname === '') return false
      if (lastname === '') return false
      if (firstnameRuby === '') return false
      if (lastnameRuby === '') return false
      if (birthYear === null) return false
      if (birthMonth === null) return false
      if (birthDay === null) return false
      // if (sex === null) return false
      if (prefecture === '') return false
      if (readFlag === null) return false
      return true
    },
    canSubmit(): boolean {
      const hasErrors = Object.values(this.formErrors).some(field => field.length !== 0)
      if (this.mode === 'create') {
        return this.isFullfilled && !hasErrors && this.isAgree
      } else {
        return this.isFullfilled && !hasErrors
      }
    },
    emailEditPath(): string {
      return buildUrl('member-email-edit')
    }
  },
  watch: {
    'fields.sex': {
      handler(val: IData['fields']['sex'], oldVal: IData['fields']['sex']) {
        if (!oldVal && val) {
          this.enableCheck('sex')
        }
      }
    }
  },
  mounted() {
    if (this.presenter.preset && this.mode === 'update') {
      const inputFields = this.$profileRepository.getUpdateProfileInputField()
      let targetData
      let targetDataBirthDate
      if (inputFields) {
        targetData = inputFields
        targetDataBirthDate = inputFields
      } else {
        targetData = this.presenter.preset.props
        targetDataBirthDate = this.presenter.preset
      }
      const { firstname, lastname, firstnameRuby, lastnameRuby, nickname, tel, zipcode, prefecture, address1, address2, address3, sex } = targetData
      const { birthYear, birthMonth, birthDay } = targetDataBirthDate
      // entityでbirthdateからgetで抽出

      this.fields = {
        ...this.fields,
        firstname,
        lastname,
        firstnameRuby,
        lastnameRuby,
        nickname,
        tel,
        birthYear,
        birthMonth,
        birthDay,
        zipcode,
        prefecture,
        address1,
        address2,
        address3,
        sex
      }

      this.enableCheckFlg = {
        ...this.enableCheckFlg,
        firstname: true,
        lastname: true,
        firstnameRuby: true,
        lastnameRuby: true,
        nickname: true,
        tel: !!tel,
        birthYear: true,
        birthMonth: true,
        birthDay: true,
        zipcode: !!zipcode,
        prefecture: true,
        address1: !!address1,
        address2: !!address2,
        address3: !!address3
      }
    } else if (this.mode === 'create') {
      const inputFields = this.$profileRepository.getCreateProfileInputField()
      if (inputFields) {
        const { firstname, lastname, firstnameRuby, lastnameRuby, prefecture, birthYear, birthMonth, birthDay, sex, readFlag } = inputFields
        this.fields = {
          ...this.fields,
          firstname,
          lastname,
          firstnameRuby,
          lastnameRuby,
          birthYear,
          birthMonth,
          birthDay,
          prefecture,
          sex,
          readFlag
        }

        this.enableCheckFlg = {
          ...this.enableCheckFlg,
          firstname: true,
          lastname: true,
          firstnameRuby: true,
          lastnameRuby: true,
          birthYear: true,
          birthMonth: true,
          birthDay: true,
          sex: true,
          prefecture: true,
          readFlag: true
        }
      }
    }
    const devProps = this.devProps
    if (devProps) {
      if (devProps.createShowError) {
        this.fields = {
          ...this.fields,
          firstname: 'rarararara',
          lastname: 'rarararara',
          firstnameRuby: 'ららららら',
          lastnameRuby: 'ららららららら',
          birthYear: null,
          birthMonth: null,
          birthDay: null,
          prefecture: '',
          sex: null,
          // @ts-ignore
          readFlag: null
        }
        this.enableCheckFlg = {
          ...this.enableCheckFlg,
          firstname: true,
          lastname: true,
          firstnameRuby: true,
          lastnameRuby: true,
          birthYear: true,
          birthMonth: true,
          birthDay: true,
          prefecture: true,
          sex: true,
          readFlag: true
        }
      }
      if (devProps.createFullfilled) {
        this.fields = {
          ...this.fields,
          firstname: '一浪',
          lastname: '鈴木',
          firstnameRuby: 'イチロー',
          lastnameRuby: 'スズキ',
          birthYear: 1990,
          birthMonth: 2,
          birthDay: 28,
          prefecture: '神奈川県',
          sex: 'm',
          readFlag: true
        }
        this.enableCheckFlg = {
          ...this.enableCheckFlg,
          firstname: true,
          lastname: true,
          firstnameRuby: true,
          lastnameRuby: true,
          birthYear: true,
          birthMonth: true,
          birthDay: true,
          prefecture: true,
          sex: true,
          readFlag: true
        }
      }
      if (devProps.updateShowError) {
        this.fields = {
          ...this.fields,
          firstname: 'rarararara',
          lastname: 'rarararara',
          firstnameRuby: 'ららららら',
          lastnameRuby: 'ららららららら',
          nickname: '',
          tel: '000',
          birthYear: null,
          birthMonth: null,
          birthDay: null,
          prefecture: '',
          sex: null,
          zipcode: null,
          address1: null,
          address2: null,
          address3: 'ららららららららららららららららららららららららららららららららららららららららららららららららららららららららららららららら',
          // @ts-ignore
          readFlag: null
        }
        this.enableCheckFlg = {
          ...this.enableCheckFlg,
          firstname: true,
          lastname: true,
          firstnameRuby: true,
          lastnameRuby: true,
          tel: true,
          birthYear: true,
          birthMonth: true,
          birthDay: true,
          prefecture: true,
          zipcode: true,
          address1: true,
          address2: true,
          address3: true,
          sex: true,
          readFlag: true
        }
      }

      if (devProps.updateFullfilled) {
        this.fields = {
          ...this.fields,
          firstname: '一浪',
          lastname: '鈴木',
          firstnameRuby: 'イチロー',
          lastnameRuby: 'スズキ',
          birthYear: 1990,
          birthMonth: 2,
          birthDay: 28,
          prefecture: '神奈川県',
          sex: 'm',
          zipcode: '1840012',
          address1: '小金井市中町',
          address2: '2-11-26',
          tel: '0423837389',
          readFlag: true
        }
        this.enableCheckFlg = {
          ...this.enableCheckFlg,
          firstname: true,
          lastname: true,
          firstnameRuby: true,
          lastnameRuby: true,
          birthYear: true,
          birthMonth: true,
          birthDay: true,
          prefecture: true,
          sex: true,
          zipcode: true,
          address1: true,
          address2: true,
          tel: true,
          readFlag: true
        }
      }
    }
  },
  methods: {
    handleBirthYearChange(birthYear: number | null) {
      this.fields = {
        ...this.fields,
        birthYear
      }
      this.enableCheck('birthYear')
    },
    handleBirthMonthChange(birthMonth: number | null) {
      this.fields = {
        ...this.fields,
        birthMonth
      }
      this.enableCheck('birthMonth')
    },
    handleBirthDayChange(birthDay: number | null) {
      this.fields = {
        ...this.fields,
        birthDay
      }
      this.enableCheck('birthDay')
    },
    handleReadFlagChange(readFlag: 'true' | 'false') {
      this.fields = {
        ...this.fields,
        readFlag: readFlag === 'true'
      }
      this.enableCheck('readFlag')
    },
    enableCheck(str: keyof ValidationTargetFields) {
      this.enableCheckFlg[str] = true
    },
    enableAllChecks() {
      if (this.mode === 'create') {
        this.enableCheckFlg = {
          ...this.enableCheckFlg,
          readFlag: true
        }
      }
      if (this.mode === 'update') {
        this.enableCheckFlg = {
          ...this.enableCheckFlg,
          nickname: true,
          zipcode: true,
          address1: true,
          address2: true,
          address3: true,
          tel: true
        }
      }
      this.enableCheckFlg = {
        ...this.enableCheckFlg,
        firstname: true,
        lastname: true,
        firstnameRuby: true,
        lastnameRuby: true,
        birthYear: true,
        birthMonth: true,
        birthDay: true,
        prefecture: true,
        sex: true
      }
    },
    async searchAddress() {
      if (!this.fields.zipcode) return
      // TODO: add validator

      try {
        const res = await new ZipcodeSearchUseCase({
          snapsnapGateway: this.$snapsnapGateway
        }).execute(this.fields.zipcode)
        const { prefecture, district } = res

        this.fields = {
          ...this.fields,
          prefecture,
          address1: district
        }

        this.enableCheckFlg = {
          ...this.enableCheckFlg,
          prefecture: true,
          address1: true
        }
      } catch (e) {
        this.$toastRepository.addQueue({
          type: 'error',
          text: '住所の検索に失敗しました'
        })
      }
    },
    submit() {
      this.enableAllChecks()

      if (!this.canSubmit) return

      if (this.mode === 'update') {
        if (!isProfileFields(this.fields)) return
        this.$profileRepository.saveUpdateProfileInputField(this.fields)
        this.$emit('success', this.fields as IProfileFields)
      } else if (this.mode === 'create') {
        const { firstname, lastname, firstnameRuby, lastnameRuby, birthYear, birthMonth, birthDay, prefecture, sex, readFlag } = this.fields

        if (typeof firstname !== 'string') return
        if (typeof lastname !== 'string') return
        if (typeof firstnameRuby !== 'string') return
        if (typeof lastnameRuby !== 'string') return
        if (typeof birthYear !== 'number') return
        if (typeof birthMonth !== 'number') return
        if (typeof birthDay !== 'number') return
        if (typeof prefecture !== 'string') return
        // if (sex !== 'f' && sex !== 'm') return
        if (typeof readFlag !== 'boolean') return

        const data: Omit<IProfileSeed, 'email' | 'password' | 'tlsc'> = {
          firstname,
          lastname,
          firstnameRuby,
          lastnameRuby,
          birthYear,
          birthMonth,
          birthDay,
          prefecture,
          sex,
          readFlag
        }
        this.$profileRepository.saveCreateProfileInputField(data)
        this.$emit('success', data)
      }
    }
  }
})
